var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BallenbakSimulation from "../d3-services/ballenbak.simulation";
import { ChartCircleGroups, } from '../svg-elements/module';
import * as _ from "lodash";
import { GraphControllerV2 } from './graph-v2';
import { breakpoints } from '../_styleguide/_breakpoints';
var Ballenbak = /** @class */ (function (_super) {
    __extends(Ballenbak, _super);
    function Ballenbak(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.simulation = {};
        _this.pre();
        return _this;
    }
    Ballenbak.prototype.pre = function () {
        if (window.innerWidth < breakpoints.sm) {
            this._addScale('x', 'band', 'vertical-reverse', 'group');
        }
        else {
            this._addScale('x', 'band', 'horizontal', 'group');
        }
        this._addScale('y', 'band', 'vertical-reverse', 'group');
        this._addScale('r', 'linear', 'radius', 'value');
        this._addMargin(20, 0, 0, 0);
        this._addPadding(10, 0, 0, 0);
    };
    Ballenbak.prototype.init = function () {
        this.config.paddingInner = 1;
        this.config.paddingOuter = 1;
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = (window.innerWidth < breakpoints.sm) ? "600px" : "360px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.config.extra.minRadius = 4;
        this.config.extra.radiusOffset = 1.8;
        this.config.extra.radiusFactor = 1.25;
        if (window.innerWidth < breakpoints.sm) {
            this.config.margin.top = 121;
            this.config.margin.bottom = 30;
            this.config.padding.right = 0;
            this.config.paddingInner = 1;
            this.config.paddingOuter = 0;
            this.config.extra.minRadius = 8;
            this.config.extra.radiusOffset = 1.5;
            this.config.extra.radiusFactor = 1;
        }
        this.chartCircleGroups = new ChartCircleGroups(this);
        this.update(this.data, this.segment, false);
    };
    Ballenbak.prototype.prepareData = function (data) {
        var mapped = [];
        // add value from most recent week to mapping .. use mapping object in vis
        for (var _i = 0, _a = this.mapping.parameters[0]; _i < _a.length; _i++) {
            var entry = _a[_i];
            var column = Array.isArray(entry.column) ? entry.column[0] : entry.column;
            var value = data[0][column];
            if (Number.isInteger(value)) {
                entry['value'] = value;
                // flattenedData.push(value);
            }
            mapped.push(entry);
        }
        return {
            "history": null,
            "latest": null,
            "slice": mapped,
            "grouped": Object.values(_.groupBy(mapped, function (d) { return d.group; }))
        };
    };
    Ballenbak.prototype.draw = function (data) {
        var self = this;
        // with data we can init scales
        this.xScale = this.scales.x.set(_.uniq(data.slice.map(function (d) { return d['group']; })));
        this.yScale = this.scales.y.set(_.uniq(data.slice.map(function (d) { return d['group']; })));
        this.rScale = this.scales.r.set(_.uniq(data.slice.map(function (d) { return d['value']; }))); // = radius !!
        this.chartCircleGroups.draw(data.grouped);
        for (var _i = 0, _a = data.grouped; _i < _a.length; _i++) {
            var group = _a[_i];
            this.simulation[group[0].group] = new BallenbakSimulation(this);
            this.simulation[group[0].group].supply(group.filter(function (prop) { return prop.value > 0; }), data.grouped.length);
        }
    };
    Ballenbak.prototype.redraw = function (data) {
        var _this = this;
        _super.prototype.redraw.call(this, data);
        this.scales.r.reset();
        this.chartCircleGroups.redraw(data.grouped);
        data.grouped.forEach(function (group, i) {
            _this.simulation[group[0].group].redraw(data.grouped.length);
        });
    };
    Ballenbak.prototype.updateForces = function (group) {
        var self = this;
        var forceStrength = 0.125;
        var groupWidth = this.dimensions.width / this.groupCount;
        var center = { x: (groupWidth / 2), y: ((this.dimensions.height / 2) + 20) };
        this.simulation[group[0].group].force("collide")
            .strength(forceStrength)
            .radius(function (d) {
            return self.scales.r.scale(d.value);
        });
        this.simulation[group[0].group].force("center")
            .x(center.x)
            .y(center.y);
        this.simulation[group[0].group].force("forceX")
            .strength(forceStrength)
            .x(center.x);
        this.simulation[group[0].group].alpha(1).restart();
    };
    Ballenbak.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return Ballenbak;
}(GraphControllerV2));
export default Ballenbak;
